module.exports = __webpack_public_path__ + "img/fruit-dates-350x184.d512e5a0.jpg";